<template>
  <modal
    name="one-bottle-confirmation-modal"
    :classes="['modal-window']"
    transition="scale"
    :width="280"
    height="auto"
    @before-open="beforeOpen"
  >
    <div class="modal-container">
      <div class="content">
        <div class="content__description">
          {{ $t('dashboard.warning.singleBottle.twoBottleByDefault') }}
        </div>
        <div class="content__question">
          {{ $t('dashboard.warning.singleBottle.agreeToDuplicate', [patientFirstName]) }}
        </div>
        <div class="content__buttons buttons flex--center--center">
          <button class="cancel-button mr20" @click="chooseCancel">
            {{ $t('dashboard.action.cancel') }}
          </button>

          <button
            class="buttons__yes rounded-button-white"
            :class="{ 'rounded-button-white__alma': isAlmaTerritory }"
            @click="chooseYes"
          >
            {{ $t('dashboard.action.yesAgree') }}
          </button>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import { mapGetters } from 'vuex';
import { types as dashTypes } from '@/modules/dashboard/store/types';
import { UNSAVED_CHANGES_INPUTS } from '@/modules/dashboard/api/constants';

import isAlmaTerritories from '@/modules/dashboard/components/mixins/isAlmaTerritories';

export default {
  name: 'OneBottleConfirmationModal',
  mixins: [isAlmaTerritories],
  data() {
    return {
      answerResolver: null
    };
  },
  computed: {
    ...mapGetters({
      patientFirstName: dashTypes.getters.CURRENT_PATIENT_FIRST_NAME
    })
  },
  methods: {
    beforeOpen({ params: { answerResolver } }) {
      this.answerResolver = answerResolver;
    },
    chooseCancel() {
      this.answerResolver(UNSAVED_CHANGES_INPUTS.CANCEL);
      this.closeModal();
    },
    chooseYes() {
      this.answerResolver(UNSAVED_CHANGES_INPUTS.YES);
      this.closeModal();
    },
    closeModal() {
      this.$modal.hide('one-bottle-confirmation-modal');
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../../../assets/scss/common/buttons';
@import '../../../../assets/scss/helpers/colors';

.content {
  padding: 30px 21px;

  &__description,
  &__question {
    font-weight: 300;
    color: $text-color;
  }

  &__description {
    padding: 12px 15px 11px;

    font-size: 11px;
    line-height: 16px;

    border-radius: 8px;
    background: $beige;
  }

  &__question {
    margin: 30px 0;

    font-size: 13px;
    line-height: 19px;
  }
}

.buttons__yes {
  min-width: 100px;
}
</style>
